export default __webpack_public_path__ + "static/media/ana.03f41fc3.jpg";